import React from 'react';
import { useFeatureFlags } from 'providers/FeatureFlagsProvider';
import { FeatureFlags } from 'UI/constants/featureFlags';

import PlacementPaymentsLegacy from './PlacementPaymentsLegacy';
import PlacementPaymentsV2 from './PlacementPaymentsV2';

/**
 * @param {Object} props
 * @param {number} props.id
 * @param {boolean} props.readOnly
 * @param {Function} props.onPaymentsChanged
 */
export const PlacementPayments = ({ id, readOnly, onPaymentsChanged }) => {
  const { checkIfFeatureFlagEnabled } = useFeatureFlags();
  const Component = checkIfFeatureFlagEnabled(FeatureFlags.PlacementPaymentsFromNetsuite)
    ? PlacementPaymentsV2
    : PlacementPaymentsLegacy;

  return <Component id={id} readOnly={readOnly} onPaymentsChanged={onPaymentsChanged} />;
};
